<template>
  <div class="cyq-result">
    <div class="content-box">
      <img class="banner-img" src="/static/images/cyq/banner2.png" alt="banner2">
      <img class="join-img" src="/static/images/cyq/join.png" alt="join" @click="handleJoinClick">
    </div>
    <img class="bg-img" src="/static/images/cyq/bg.png" alt="bg">
  </div>
</template>

<script>
import { getWechatAuth } from '../../api/api'

export default {
  name: 'CyqResult',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wxb576b8e7ccb1ad66' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138548738944' : '138495952793',
      code: '',
      deptId: ''
    }
  },
  mounted() {
    if (this.$route.query.c) {
      this.code = this.$route.query.c
    }
    if (this.$route.query.deptId) {
      this.deptId = this.$route.query.deptId
    }
  },
  methods: {
    handleJoinClick() {
      const redirectUrl = window.location.origin + '/cyq/activity'
      const params = new URLSearchParams()
      params.append('c', this.code)
      params.append('deptId', this.deptId)
      
      const fullRedirectUrl = redirectUrl + '?' + params.toString()
      
      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data
        window.location.href = data
      }).catch(err => {
        alert("获取微信授权失败" + err)
      })
    }
  }
}
</script>

<style scoped>
.cyq-result {
  width: 100vw;
  min-height: 100vh;
  background: white;
}

.content-box {
  width: 100vw;
  height: 90vh;
  margin: 8vh auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.banner-img {
  width: 100%;
  height: auto;
}

.join-img {
  margin-top: 4vh;
  width: 70%;
  margin-left: 4vw;
  height: auto;
}

.bg-img {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: auto;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Cyq/Result.vue